import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const UnderConstructionPage = ({ audioEnabled, onOpenMenu }) => {
  const navigate = useNavigate();
  const [displayedText, setDisplayedText] = useState('');
  // const [cursorVisible, setCursorVisible] = useState(true);

  const fullText = 'Section UNDER DEVELOPEMENT...';

  // Typewriter effect
  useEffect(() => {
    if (displayedText.length < fullText.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(fullText.slice(0, displayedText.length + 1));
      }, 80);
      return () => clearTimeout(timeout);
    }
  }, [displayedText]);

  // Cursor blink
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCursorVisible((prev) => !prev);
  //   }, 500);
  //   return () => clearInterval(interval);
  // }, []);

  return (
    <div className="relative w-full min-h-screen bg-black overflow-hidden flex items-center justify-center">
      {/* Subtle background grid */}
      <div className="absolute inset-0" style={{ opacity: 0.15 }}>
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#e48c1e" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      {/* Main content - minimalistic */}
      <div className="relative z-10 text-center max-w-lg mx-auto px-6 space-y-12">
        {/* Header */}
        <div>
          <h1 className="font-sakana text-4xl text-custom-yellow relative inline-block">
            <span className="drop-shadow-lg">{displayedText}</span>
            {/* <span
              className={`ml-2 inline-block w-1 h-10 bg-custom-yellow ${
                cursorVisible ? 'opacity-100' : 'opacity-0'
              } transition-opacity`}
            /> */}
          </h1>
          <p className="font-mono text-custom-yellow/50 text-sm mt-4">
            New protocols incoming. Stay tuned.
          </p>
        </div>

        {/* Action buttons */}
        <div className="flex flex-col gap-4 pt-8">
          <button
            onClick={() => onOpenMenu ? onOpenMenu() : navigate('/')}
            className="relative px-6 py-2 text-custom-yellow font-sakana text-lg border border-custom-yellow bg-transparent 
                       hover:bg-custom-yellow/10 transition-all duration-300 group overflow-hidden"
          >
            <span className="relative z-10">Okay, Explore other pages</span>
            <div className="absolute inset-0 bg-custom-yellow/5 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
          </button>

          <a
            href="mailto:divyaagrawal0747@gmail.com?subject=MISSION%20FAILURE:%20Page%20Under%20Construction"
            className="relative px-6 py-2 text-custom-yellow/70 font-sakana text-lg border border-custom-yellow/50 bg-transparent 
                       hover:text-custom-yellow hover:border-custom-yellow hover:bg-custom-yellow/10 transition-all duration-300 group overflow-hidden"
          >
            <span className="relative z-10">File a disappointment</span>
            <div className="absolute inset-0 bg-custom-yellow/5 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default UnderConstructionPage;
